module.exports = __webpack_public_path__ + "img/sosdenuncia.07687e79.png";